import styled from '@emotion/styled'
import { theme } from '@hhgtech/hhg-components'
import { AspectRatio, rem } from '@mantine/core'

export const StyledCardCommunityFooter = styled.div`
  margin-top: ${rem(12)};
`

export const StyledCardCommunityMember = styled.p`
  flex: 1;
  min-width: 0;
  margin-top: ${rem(4)};
  color: ${theme.colors.gray600};
  span {
    color: ${theme.colors.gray800};
  }
`

export const StyledCardCommunityTitleLink = styled.a``

export const StyledCardCommunityTitle = styled.p`
  color: ${theme.colors.gray800};
  font-size: ${rem(16)};
  font-weight: 600;
  line-height: ${rem(24)};
  margin-bottom: 0;
`

export const StyledCardCommunityContent = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-block: ${rem(12)};
  padding-inline: ${rem(12)};
`

export const StyledCardCommunityImageRatio = styled(AspectRatio)``

export const StyledCardCommunityImageLink = styled.a`
  display: block;
  width: 100%;
  height: 100%;
  border-radius: ${rem(8)};
  overflow: hidden;
`

export const StyledCardCommunityImageWrap = styled.div`
  padding: ${rem(8)};
  padding-bottom: 0;
`

export const StyledCardCommunity = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: ${rem(16)};
  border: 1px solid ${theme.colors.neutral100};

  [disabled] {
    pointer-events: none;
  }
`
